import { render, staticRenderFns } from "./QuoteBuilderSubletComponent.vue?vue&type=template&id=22a0460a&scoped=true"
import script from "./QuoteBuilderSubletComponent.vue?vue&type=script&lang=js"
export * from "./QuoteBuilderSubletComponent.vue?vue&type=script&lang=js"
import style0 from "./QuoteBuilderSubletComponent.vue?vue&type=style&index=0&id=22a0460a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a0460a",
  null
  
)

export default component.exports